import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import PlatformModal from '../../modals/platform_modal';
import Divider from '../../utilities/divider';

import styles from './index.module.css';

const PartnersGalleryModal = ({ patientPartner, onClose }) => {
  const [showModal, setShowModal] = useState(true);
  const history = useHistory();
  const treatmentRetentionUrl =
    patientPartner?.account_treatment_retention_url || 'https://patient.patientpartner.com/member/join/pre-signup';

  const handleClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (!showModal && onClose) {
      onClose();
    }
  }, [showModal, onClose]);

  const handleCreateAccount = () => {
    const url = `${treatmentRetentionUrl}?patient_partner_id=${patientPartner?.id}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    handleClose();
  };

  const handleLogin = () => {
    const url = `/member/login?patient_partner_id=${patientPartner?.id}`;
    history.push(url);
    handleClose();
  };

  const titleCase = (string) => {
    if (!string) return '';
    var surgery = string.toLowerCase().split(' ');
    for (var i = 0; i < surgery.length; i++) {
      if (surgery[i][0]) {
        surgery[i] = surgery[i][0].toUpperCase() + surgery[i].slice(1);
      }
    }
    return surgery.join(' ');
  };

  const getImageUrl = () => patientPartner?.profile?.photo || null;

  if (!showModal) return null;

  return (
    <PlatformModal
      setModal={setShowModal}
      title={`Sign up or log in to connect with ${patientPartner?.name || 'a Mentor'}.`}
      content={
        <div className={styles.content}>
          {patientPartner && (
            <>
              <div className={styles.partnerInfo}>
                <div
                  className={styles.avatar}
                  style={{
                    backgroundImage: getImageUrl() ? `url('${getImageUrl()}')` : 'none',
                    backgroundColor: getImageUrl() ? 'transparent' : '#e0e0e0',
                  }}
                />
                <h5 className={styles.name}>{patientPartner.name}</h5>
                {Array.isArray(patientPartner.focus_areas) && patientPartner.focus_areas.length > 0 && (
                  <h4 className={styles.surgeries}>
                    {patientPartner.focus_areas
                      .slice()
                      .sort()
                      .map((str) => titleCase(str))
                      .join(', ')}
                  </h4>
                )}
                {patientPartner.display_location && (
                  <p className={styles.location}>{patientPartner.display_location}</p>
                )}
                <Divider color={'#888888'} />
                {patientPartner.bio && (
                  <div className={styles.bio}>
                    <span>{patientPartner.bio}</span>
                  </div>
                )}
              </div>
            </>
          )}
          <div className={styles.buttonsContainer}>
            <button onClick={handleCreateAccount} className={`submit ${styles.button}`}>
              Create an account
            </button>
            <button onClick={handleLogin} className={`liner ${styles.button}`}>
              Log in
            </button>
          </div>
        </div>
      }
      onCancel={handleClose}
      cancelCta=''
      allowClose={true}
      width={8}
    />
  );
};

export default PartnersGalleryModal;
